import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Sparte } from '@mwe/models';
import { NgClass } from '@angular/common';
import { CategoryIconSrcPipe, TranslateCategoryPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-small-product-list',
  templateUrl: './small-product-list.component.html',
  styles: [':host { display: block; width: 100% }'],
  imports: [NgClass, TranslateCategoryPipe, CategoryIconSrcPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallProductListComponent {
  categories = input.required<Sparte[]>();
  isPositionedInCenter = input(true);
}
